import React, { Suspense } from 'react';
import Initializer from './container/Initializer';
import { PostHogProvider } from 'posthog-js/react';

const CampaignReferral = () => {
	const posthogOptions = {
		disable_session_recording: true,
		element_selector_allowlist: ['a', 'input', 'select', 'button', 'label'],
		loaded: (posthog) => {
			if (process.env.NODE_ENV === 'production')
				posthog.startSessionRecording();
		},
	};

	return (
		<PostHogProvider
			apiKey={process.env.CAMPAIGN_REFERRAL_POSTHOG}
			options={posthogOptions}
		>
			<Suspense fallback={null}>
				<Initializer />
			</Suspense>
		</PostHogProvider>
	);
};
export default CampaignReferral;
